<template>
  <div class="product-pushstatus-set">
    <vh-dialog :title="$t('lang.k_310001')" :visible.sync="visible" width="520px">
      <div class="sale-type-box">
        <div class="btn-label">{{ $t('lang.k_310002') }}</div>
        <vh-radio-group v-model="status">
          <vh-radio :label="1">{{ $t('lang.k_310003') }}</vh-radio>
          <vh-radio :label="2">{{ $t('lang.k_310004') }}</vh-radio>
          <vh-radio :label="0">{{ $t('lang.k_310005') }}</vh-radio>
        </vh-radio-group>
      </div>
      <article>
        {{ $t('lang.k_310006') }}
        <br />
        {{ $t('lang.k_310007') }}
        <br />
        {{ $t('lang.k_310008') }}
      </article>
      <template v-if="!Array.isArray(editProduct)">
        <div class="sale-type-box pushstatus-radio">
          <div class="btn-label">{{ $t('lang.k_310009') }}</div>
          <vh-radio-group v-model="preSaleType">
            <vh-radio :label="1">{{ $t('lang.k_310010') }}</vh-radio>
            <vh-radio :label="0">{{ $t('lang.k_310011') }}</vh-radio>
          </vh-radio-group>
        </div>
        <div class="btn-text-box" v-show="preSaleType == 1">
          <div class="btn-label">
            <span style="color: #fb3a32; margin-right: 4px">*</span>
            {{ $t('lang.k_310012') }}
          </div>
          <vh-input
            v-model.trim="pre_sale_button_desc"
            class="btn-input"
            size="medium"
            :maxlength="15"
            show-word-limit
          ></vh-input>
        </div>
        <article>{{ $t('lang.k_310013') }}</article>
        <div class="sale-type-box">
          <div class="btn-label">{{ $t('lang.k_310014') }}</div>
          <vh-radio-group v-model="auto_pop">
            <vh-radio :label="1">{{ $t('lang.k_310015') }}</vh-radio>
            <vh-radio :label="0">{{ $t('lang.k_310016') }}</vh-radio>
          </vh-radio-group>
        </div>
        <article>{{ $t('lang.k_310017') }}</article>
      </template>
      <footer>
        <vh-button plain round type="info" size="medium" @click="cancel">
          {{ $t('lang.k_310018') }}
        </vh-button>
        <vh-button v-preventReClick type="primary" round size="medium" @click="confirm">
          {{ $t('lang.k_310019') }}
        </vh-button>
      </footer>
    </vh-dialog>
  </div>
</template>

<script>
  import { setAdminProductStatus, batchChangeStatus } from '@vhcl/product';
  export default {
    data() {
      return {
        status: 0,
        visible: false,
        preSaleType: 0, // 预售类型：是否预售;(0.非预售  1.预售)
        auto_pop: 0, // 是否自动推屏(0.否  1.是)
        pre_sale_button_desc: this.$t('lang.k_310020'),
        editProduct: null
      };
    },
    methods: {
      confirm() {
        if (Array.isArray(this.editProduct)) {
          batchChangeStatus({ webinar_goods_ids: this.editProduct, status: +this.status }).then(
            res => {
              if (res.code == 200) {
                this.$vhMessage.success(this.$t('lang.k_310021'));
                this.visible = false;
                this.$emit('success');
              } else {
                this.$vhMessage.error(this.$t('lang.k_310022'));
              }
            }
          );
          return;
        }
        if (this.preSaleType === 1 && !this.pre_sale_button_desc) {
          this.$vhMessage.error(this.$t('lang.k_310023'));
          return false;
        }
        setAdminProductStatus({
          webinar_goods_id: this.editProduct?.webinar_goods_id,
          status: +this.status,
          pre_sale: this.preSaleType,
          auto_pop: this.auto_pop,
          pre_sale_button_desc: this.pre_sale_button_desc
        })
          .then(res => {
            if (res.code == 200) {
              this.$vhMessage.success(this.$t('lang.k_310021'));
              this.visible = false;
              this.$emit('success');
            } else {
              this.$vhMessage.error(this.$t('lang.k_310022'));
            }
          })
          .catch(() => {
            this.$vhMessage.error(this.$t('lang.k_310022'));
          });
      },
      cancel() {
        this.visible = false;
      },
      open(product) {
        this.editProduct = product;
        if (Array.isArray(product)) {
          this.visible = true;
          return;
        }
        this.preSaleType = product?.pre_sale || 0;
        this.auto_pop = product?.auto_pop || 0;
        this.pre_sale_button_desc = product?.pre_sale_button_desc || this.$t('lang.k_310020');
        this.status = product.status || 0;
        this.visible = true;
      }
    }
  };
</script>

<style lang="less" scoped>
  .product-pushstatus-set {
    .pushstatus-radio {
    }
    article {
      font-size: 12px;
      line-height: 20px;
      color: rgba(0, 0, 0, 0.45);
      white-space: normal;
      word-break: break-word;
      overflow-wrap: break-word;
    }
    footer {
      margin-top: 24px;
      text-align: right;
    }

    .btn-text-box,
    .sale-type-box {
      display: flex;
      align-items: center;
      margin-top: 24px;

      .btn-label {
        vertical-align: middle;
        font-size: 14px;
        color: #262626;
        line-height: 40px;
        padding: 0 12px 0 0;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 55px;
      }
    }
    .sale-type-box:first-child {
      margin-top: 0;
    }

    .btn-text-box {
      padding-left: 55px;
      .btn-label {
        font-size: 12px;
        width: 92px;
      }
    }
  }
</style>
